// src/shared/store/useBottomSheetStore.ts
import { create } from 'zustand';

export type BottomSheetType =
  | 'star-point-consume'
  | 'message'
  | 'earn-point'
  | 'reward-success'
  | 'select-era-list'
  | 'person-info'
  | 'exit-quiz'
  | 'retry-quiz'
  | 'delete-member'
  | 'update-nickname'
  | 'not-played'
  | null;

interface BottomSheetState {
  type: BottomSheetType;
  props?: Record<string, any>;
  isOpen: boolean;
}

interface BottomSheetActions {
  openSheet: (type: BottomSheetType, props?: Record<string, any>) => void;
  closeSheet: () => void;
  updateProps: (props: Record<string, any>) => void;
}

type BottomSheetStore = BottomSheetState & BottomSheetActions;

const useBottomSheetStore = create<BottomSheetStore>(set => ({
  // State
  type: null,
  props: undefined,
  isOpen: false,

  // Actions
  openSheet: (type, props) =>
    set({
      type,
      props,
      isOpen: true,
    }),

  closeSheet: () =>
    set({
      type: null,
      props: undefined,
      isOpen: false,
    }),

  updateProps: props =>
    set(state => ({
      props: { ...state.props, ...props },
    })),
}));

export default useBottomSheetStore;
